import { BoardColumns, BoardData, boardEntityName } from '@/backend/features/board-files/shared';
import { useBoardFormConfig } from '@/ui/features/board-files/hooks/useBoardFormConfig';
import { BoardFormDataType } from '@/ui/features/board-files/types/BoardFormDataType';
import { useTranslation } from '@/ui/hooks';
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
import React from 'react';

export function useHandleAddBoard(side: 'generic' | 'industry', reload: () => void) {
    const { t } = useTranslation();
    const formConfig = useBoardFormConfig(side);
    const boardStorage = useStorageClient<BoardData, BoardColumns>(boardEntityName);
    return React.useCallback(() => {
        showFormDialog({
            title: t('addBoard'),
            config: formConfig,
            data: {
                board: '',
                description: {
                    html: '',
                },
            } satisfies BoardFormDataType,
            onSubmit: ({ board, type, industry, description }: BoardFormDataType) => {
                return boardStorage
                    .post({
                        action: 'create',
                        data: {
                            board,
                            type,
                            industry,
                            descriptionHtml: description.html,
                            files: [],
                        },
                    })
                    .then(() => reload())
                    .catch((error) => {
                        handleErrorDialog(error);
                        throw error;
                    });
            },
        });
    }, [reload, t, formConfig, boardStorage]);
}
